import React from "react";

type Props = {
    currencies: { key: string; label: string }[];
    currencyKey: string;
    onCurrency: (key: string) => void;
};

/** D103 + D129: every figure on the page belongs to ONE currency; a small select, only when there is a choice. */
export const CurrencySelector: React.FC<Props> = ({ currencies, currencyKey, onCurrency }) =>
    currencies.length <= 1 ? null : (
        <select className="daily-select daily-currency-select" aria-label="Moneda" value={currencyKey} onChange={(event) => onCurrency(event.target.value)}>
            {currencies.map((currency) => (
                <option key={currency.key} value={currency.key}>{currency.label}</option>
            ))}
        </select>
    );
